import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import LoadingSpinner from '../components/common/LoadingSpinner';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('OAuth callback error:', error);
          navigate('/auth?error=oauth_failed');
          return;
        }

        if (data.session) {
          // 登录成功，重定向到首页或之前的页面
          const redirectTo = sessionStorage.getItem('auth_redirect_to') || '/';
          sessionStorage.removeItem('auth_redirect_to');
          navigate(redirectTo);
        } else {
          // 没有session，重定向到登录页
          navigate('/auth');
        }
      } catch (error) {
        console.error('处理OAuth回调时出错:', error);
        navigate('/auth?error=callback_failed');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-cyan-50 flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner />
        <p className="mt-4 text-gray-600">正在处理登录...</p>
      </div>
    </div>
  );
};

export default AuthCallback;